import { Controller } from "@hotwired/stimulus"
import * as Credential from "src/credential";

export default class extends Controller {

  async submit(event) {
    event.preventDefault()

    const formData = new FormData(this.element)

    try {
      const response = await fetch(this.element.action, {
        method: "POST",
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("[name='csrf-token']").content
        },
        body: formData
      })

      const data = await response.json()

      if (response.ok) {
        // Start WebAuthn authentication
        await Credential.get(data)
      } else {
        this.showError(data)
      }

    } catch (err) {
      console.error(err)
      showMessage(["Network error"])
    }
  }

  showError(data) {
    if (!data.errors) {
      showMessage(["Unknown error"])
      return
    }

    const input = document.querySelector('input[name="session[email]"]')
    input.classList.add("is-invalid")

    let message = input.parentElement.querySelector(".invalid-feedback")

    if (!message) {
      message = document.createElement("div")
      message.classList.add("invalid-feedback")
      input.after(message)
    }

    message.innerHTML = data.errors[0]
  }

}
